<template >
    <boxDropDown title="Parametrização de turno para 24 horas">
      <template class="support-tools">

        <div class="form-group col-md-12 support-tools__warning">
          <span><b>Atenção: </b>Para parametrizar um turno para 24 horas, necessita-se criar um turno livre antes.</span>
        </div>
        <div class="form-group col-xs-6 col-sm-6 col-md-6">
          <label for="companyIdInput">ID da empresa</label>
          <input type="text" class="form-control" placeholder="Insira o ID da empresa" id="companyIdInput" name="companyIdInput" 
          v-model="companyId" @blur="checkField('companyIdInput')">
        </div>
  
        <div class="form-group col-xs-6 col-sm-6 col-md-6">
          <label for="workshiftIdInput">ID do turno</label>
          <input type="text" class="form-control" placeholder="Insira o ID do turno" id="workshiftIdInput" name="workshiftIdInput" 
          v-model="workshiftId" @blur="checkField('workshiftIdInput')">
        </div>
  
        <div v-if="errorMessage" class="text-danger col-xs-12 col-sm-12 col-md-12 text-center spacing-bottom" role="alert">
          {{ errorMessage }}
        </div>
  
        <div class="form-group col-md-12 full-width text-center">
          <button class="btn btn-primary" :disabled="isDisabled()" @click="handleSwitchWorkShiftToSchedule()">
            <span v-if="!loadingSwitchWorkShiftToSchedule">Enviar</span>
            <span v-else class="loading-btn">
              <div class="spinner-btn">
                <div class="rect1"></div>
                <div class="rect2"></div>
                <div class="rect3"></div>
                <div class="rect4"></div>
                <div class="rect5"></div>
              </div>
            </span>
          </button>
        </div>
      </template>
    </boxDropDown>
  </template>
  
  <script>
  import {
    CONTEXT_COMPANY,
    SWITCH_WORKSHIFT_TO_SCHEDULE,
  } from "../../../../../urlConfig";
  import {
    REQUEST_SERVICE
  } from "../../../../../requestConfig";
  import {
    ALERT_SERVICE
  } from "../../../../../msgAlertService";
  import boxDropDown from "../../../components/layouts/boxDropDown.vue";
  
  export default {
      name: "switch-workshift-to-schedule",
      components: {
        boxDropDown
      },
      data() {
        return {        
          companyId: '',
          workshiftId: '',
          errorMessage: '',
          contentSetting: '',
          loadingSwitchWorkShiftToSchedule: false
        }
      },
      methods: {
        isDisabled(){
        return this.loadingSwitchWorkShiftToSchedule;
      },
        handleSwitchWorkShiftToSchedule(){
          this.checkField("workshiftIdInput");
          if(this.errorMessage != ''){
            return;
          }
  
          this.checkField("companyIdInput");
          if(this.errorMessage != ''){
            return;
          }
  
          this.loadingSwitchWorkShiftToSchedule = true;
          
          REQUEST_SERVICE.get(`${CONTEXT_COMPANY}${this.companyId}`).then((response) => {
            this.contentSetting = response.data;
  
            let url = `${SWITCH_WORKSHIFT_TO_SCHEDULE}?companyId=${this.companyId}&workshiftId=${this.workshiftId}`
            console.log(url);
            REQUEST_SERVICE.requestContext('PUT', url, this.contentSetting).then((response) => {
              ALERT_SERVICE.swal("Sucesso", "Parametrização efetuada com sucesso!", "success");
              this.clearFields();
              this.loadingSwitchWorkShiftToSchedule = false;
            }).catch((reason) => {
              this.loadingSwitchWorkShiftToSchedule = false;
              if(reason.response.data.erros.length > 0){
                ALERT_SERVICE.swal("ERRO", reason.response.data.erros[0].value, "error");
              }else{
                ALERT_SERVICE.swal("ERRO", "Entre em contato com a equipe de desenvolvimento", "error");
              }
            });
          }).catch((reason) => {
            this.loadingSwitchWorkShiftToSchedule = false;
            if(reason.response.data.erros.length > 0){
                ALERT_SERVICE.swal("ERRO", reason.response.data.erros[0].value, "error");
              }else{
                ALERT_SERVICE.swal("ERRO", "Entre em contato com a equipe de desenvolvimento", "error");
              }
          });
        },
        checkField(nameOfInput){
          if(nameOfInput === "companyIdInput" || nameOfInput === "workshiftIdInput"){
            if(this.companyId.trim().length != 32 || this.workshiftId.trim().length != 32){
              this.errorMessage = "Os IDs devem conter 32 caracteres";
              return;
            }
          }
          this.errorMessage= '';
        },
        clearFields(){
          this.companyId = '';
          this.workshiftId = '';
          this.errorMessage = '';
          this.contentSetting = '';
        }
      }
    }
    </script>

    <!-- <style scoped> -->
    <style lang="scss">

    * {
      font-family: "Montserrat", sans-serif !important;
    }

    .support-tools {
      &__warning {
        padding: 10px;
        text-align: center;
        background-color: #FFDF8D;
        border-radius: 8px !important;
        color: #FF445D;
      }
    }

    .full-width{
      width: 100% !important;
    }

    .spacing-bottom{
      margin-bottom: 8px;
    }


    ul{
      list-style: none;
    }


    </style>


// WEBPACK FOOTER //
// src/vue/pages/restricted/support/supportItems/switchWorkShiftToSchedule.vue